/* ==========================================================================
   Kopstorm CRO Suite - Wave 3 - kopstorm-w3.js
   Anavrin / byanavrin.com

   W39  Kit check quiz, opened from the badge on the first gallery image
   W41  Objection tabs above the buy button
   W44  Instant filter chips above the collection grid
   W48  Completion Guarantee module (markup only, no behaviour needed)

   The flag engine from 'kopstorm-cro-flags' is reused as is, so Intelligems
   keeps the same one line contract:

       KopstormCRO.enable('w39')   /   KopstormCRO.disable('w39')
       ?kop=w39                    for QA in the browser

   All copy and all product data arrive on window.KopstormW3, written by
   snippets/kopstorm-w3-flags.liquid and snippets/kopstorm-w3-quiz.liquid.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var config = window.KopstormW3 || {};

  var TESTS = [
    { id: 'w39', label: 'Kit check quiz on the gallery' },
    { id: 'w41', label: 'Objection tabs above the buy button' },
    { id: 'w44', label: 'Instant filter chips on collections' },
    { id: 'w48', label: 'Completion Guarantee module' }
  ];

  /* ------------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------------ */
  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function on(id) {
    return root.classList.contains('kop-' + id);
  }

  function text(value) {
    return typeof value === 'string' ? value : '';
  }

  /* Copy tokens are square bracketed on purpose. A Liquid output tag cannot
     hold another output tag inside a string literal, so nothing in this suite
     ever uses the {{ }} shape for a placeholder. */
  function fill(template, values) {
    return text(template).replace(/\[([a-z0-9_]+)\]/gi, function (match, key) {
      var value = values[key];
      return value === undefined || value === null || value === '' ? '' : String(value);
    }).replace(/\s{2,}/g, ' ').trim();
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || null;
    var amount = (Number(cents) / 100).toFixed(2);
    if (!format) return amount;
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function icon(name) {
    var paths = {
      check: '<polyline points="20 6 9 17 4 12"></polyline>',
      shield: '<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"></path><polyline points="9 12 11 14 15 10"></polyline>',
      clock: '<circle cx="12" cy="12" r="8.5"></circle><polyline points="12 7 12 12 15.5 14"></polyline>',
      close: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
      spark: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18"></path>'
    };
    if (!paths[name]) return '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths[name] + '</svg>';
  }

  function addToCart(variantId, quantity) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (response) {
      return response.json();
    }).then(function (payload) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      return payload;
    });
  }

  /* ========================================================================
     W39 - kit check quiz
     ======================================================================== */
  var quiz = {
    node: null,
    answers: {},
    step: 0,
    steps: [],

    init: function () {
      this.node = $('[data-kop3-quiz]');
      if (!this.node || this.node.dataset.built === 'true') return;
      this.node.dataset.built = 'true';

      this.steps = $$('[data-kop3-step]', this.node);
      this.result = $('[data-kop3-result]', this.node);
      this.foot = $('[data-kop3-quiz-foot]', this.node);
      this.pips = $$('[data-kop3-pip]', this.node);

      var self = this;

      $$('[data-kop3-option]', this.node).forEach(function (button) {
        button.addEventListener('click', function () {
          var step = button.closest('[data-kop3-step]');
          var key = step.getAttribute('data-kop3-step');

          $$('[data-kop3-option]', step).forEach(function (other) {
            other.classList.toggle('is-picked', other === button);
          });

          self.answers[key] = button.getAttribute('data-kop3-option');
          window.setTimeout(function () { self.next(); }, 160);
        });
      });

      $$('[data-kop3-back]', this.node).forEach(function (button) {
        button.addEventListener('click', function () { self.go(self.step - 1); });
      });

      $$('[data-kop3-quiz-close]', this.node).forEach(function (button) {
        button.addEventListener('click', function () { self.close(); });
      });

      var scrim = $('[data-kop3-scrim]', this.node);
      if (scrim) scrim.addEventListener('click', function () { self.close(); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !self.node.hidden) self.close();
      });

      var cta = $('[data-kop3-quiz-add]', this.node);
      if (cta) {
        cta.addEventListener('click', function () {
          var id = self.variantId();
          if (!id) return;
          cta.disabled = true;
          addToCart(id, 1)
            .then(function () { self.close(); })
            .catch(function () { cta.disabled = false; });
        });
      }
    },

    /* The live variant wins over the one rendered at page load, so the quiz
       always adds whatever the buy box currently has selected. */
    variantId: function () {
      var input = $('form[action*="/cart/add"] [name="id"]');
      var live = input && input.value ? input.value : null;
      return live || (config.product && config.product.variantId) || null;
    },

    open: function () {
      this.init();
      if (!this.node) return;

      this.node.hidden = false;
      /* Two frames, so the opening transition has a starting state to run from. */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          quiz.node.classList.add('is-open');
        });
      });

      document.documentElement.classList.add('kop3-locked');
      document.body.classList.add('kop3-locked');
      this.go(0);

      var first = $('[data-kop3-option]', this.node);
      if (first) first.focus({ preventScroll: true });

      document.dispatchEvent(new CustomEvent('kopstorm:w39:open'));
    },

    close: function () {
      if (!this.node) return;
      this.node.classList.remove('is-open');
      document.documentElement.classList.remove('kop3-locked');
      document.body.classList.remove('kop3-locked');

      var node = this.node;
      window.setTimeout(function () { node.hidden = true; }, 220);
    },

    go: function (index) {
      if (index < 0) index = 0;
      this.step = index;

      var body = $('[data-kop3-quiz-body]', this.node);
      if (body) body.scrollTop = 0;

      this.steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });

      var onResult = index >= this.steps.length;
      if (this.result) this.result.hidden = !onResult;
      if (this.foot) this.foot.hidden = !onResult;

      this.pips.forEach(function (pip, i) {
        pip.classList.toggle('is-done', i < index || onResult);
      });

      if (onResult) this.paint();
    },

    next: function () {
      this.go(this.step + 1);
    },

    /* Build time is authored as free text ("4 to 6 hours"), so the largest
       number in the string is the honest upper bound to reason about. */
    hours: function () {
      var source = (config.product && config.product.time) || '';
      var found = source.match(/\d+/g);
      if (!found) return 0;
      return found.map(Number).reduce(function (a, b) { return Math.max(a, b); }, 0);
    },

    verdict: function () {
      var copy = config.quiz || {};
      var product = config.product || {};
      var level = Number(product.difficulty) || 1;
      var experience = this.answers.experience || 'new';
      var pace = this.answers.pace || 'weekend';
      var recipient = this.answers.recipient || 'self';

      var key = 'match';
      if (level === 1) key = 'easy';
      else if (level === 3 && experience === 'new') key = 'stretch';
      else if (level === 2 && experience === 'new') key = 'step';
      else if (experience === 'often') key = 'confident';

      var values = {
        title: product.title || '',
        time: product.time || '',
        pieces: product.pieces || '',
        difficulty: product.difficultyLabel || ''
      };

      var points = (copy.points || []).slice();
      if (recipient === 'gift' && copy.point_gift) points.push(copy.point_gift);
      if (product.glue && copy.point_glue) points.push(copy.point_glue);

      var aside = '';
      if (key === 'stretch' && copy.aside_stretch) aside = copy.aside_stretch;
      else if (pace === 'evening' && this.hours() > 6 && copy.aside_time) aside = copy.aside_time;

      return {
        key: key,
        title: fill((copy.verdict_title || {})[key] || copy.verdict_title_default, values),
        text: fill((copy.verdict_text || {})[key] || copy.verdict_text_default, values),
        points: points.map(function (point) { return fill(point, values); }),
        aside: fill(aside, values)
      };
    },

    paint: function () {
      if (!this.result) return;

      var outcome = this.verdict();
      var title = $('[data-kop3-result-title]', this.result);
      var body = $('[data-kop3-result-text]', this.result);
      var list = $('[data-kop3-result-points]', this.result);
      var aside = $('[data-kop3-result-aside]', this.result);

      if (title) title.textContent = outcome.title;
      if (body) body.textContent = outcome.text;

      var mark = $('[data-kop3-result-mark]', this.result);
      if (mark) mark.innerHTML = icon(outcome.key === 'stretch' ? 'clock' : 'check');

      if (list) {
        list.innerHTML = '';
        outcome.points.forEach(function (point) {
          if (!point) return;
          var item = document.createElement('li');
          item.className = 'kop3-result__point';
          item.innerHTML = icon('check') + '<span></span>';
          item.querySelector('span').textContent = point;
          list.appendChild(item);
        });
      }

      if (aside) {
        if (outcome.aside) {
          var link = (config.quiz && config.quiz.aside_url) || '';
          var label = (config.quiz && config.quiz.aside_link) || '';
          aside.innerHTML = '';
          var line = document.createElement('span');
          line.textContent = outcome.aside + ' ';
          aside.appendChild(line);
          if (link && label) {
            var anchor = document.createElement('a');
            anchor.href = link;
            anchor.textContent = label;
            aside.appendChild(anchor);
          }
          aside.hidden = false;
        } else {
          aside.hidden = true;
        }
      }

      var product = config.product || {};
      var facts = { time: product.time, level: product.difficultyLabel, pieces: product.pieces };

      Object.keys(facts).forEach(function (key) {
        var cell = $('[data-kop3-fact="' + key + '"]', this.result);
        if (!cell) return;
        var value = facts[key];
        cell.hidden = !value;
        if (value) {
          var slot = $('[data-kop3-fact-value="' + key + '"]', cell);
          if (slot) slot.textContent = value;
        }
      }, this);

      /* A single remaining cell reads as a stray box, so the row is dropped
         unless there are at least two facts to show. */
      var row = $('[data-kop3-result-facts]', this.result);
      if (row) {
        var shown = $$('[data-kop3-fact]', row).filter(function (cell) { return !cell.hidden; });
        row.style.display = shown.length > 1 ? '' : 'none';
        row.style.gridTemplateColumns = 'repeat(' + Math.max(shown.length, 1) + ', minmax(0, 1fr))';
      }

      var price = $('[data-kop3-quiz-price]', this.node);
      if (price && product.price) {
        price.textContent = formatMoney(product.price);
      }
    }
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-kop3-quiz-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    quiz.open();
  });

  /* ========================================================================
     W41 - objection tabs
     ======================================================================== */
  function tabs() {
    $$('[data-kop3-faq]').forEach(function (group) {
      if (group.dataset.built === 'true') return;
      group.dataset.built = 'true';

      var buttons = $$('[data-kop3-tab]', group);
      var panels = $$('[data-kop3-panel]', group);

      function select(index) {
        buttons.forEach(function (button, i) {
          button.setAttribute('aria-selected', i === index ? 'true' : 'false');
          button.setAttribute('tabindex', i === index ? '0' : '-1');
        });
        panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
        });
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () { select(index); });
        button.addEventListener('keydown', function (event) {
          var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          var target = (index + step + buttons.length) % buttons.length;
          buttons[target].focus();
          select(target);
        });
      });

      select(0);
    });
  }

  /* ========================================================================
     W44 - instant filter chips
     ======================================================================== */
  var chips = {
    node: null,
    cards: [],
    active: {},

    init: function () {
      this.node = $('[data-kop3-chips]');
      if (!this.node) return;

      this.status = $('[data-kop3-chips-status]', this.node);
      this.empty = $('[data-kop3-chips-empty]', this.node);
      this.clear = $('[data-kop3-chips-clear]', this.node);
      this.grid = document.getElementById('ProductGridContainer');

      var self = this;

      if (this.node.dataset.built !== 'true') {
        this.node.dataset.built = 'true';

        $$('[data-kop3-chip]', this.node).forEach(function (chip) {
          chip.addEventListener('click', function () { self.toggle(chip); });
        });

        if (this.clear) {
          this.clear.addEventListener('click', function () { self.reset(); });
        }

        /* The facet form replaces the whole grid on every server filter, so the
           card index is rebuilt whenever its children change. */
        if (this.grid && window.MutationObserver) {
          new MutationObserver(function () {
            self.index();
            self.apply();
          }).observe(this.grid, { childList: true, subtree: true });
        }

        /* The chip row sits outside #ProductGridContainer, so a server filter
           never refreshes it and a chip answered by the server would keep
           showing as unselected. The facet response carries the whole section,
           including a freshly rendered row, so it is lifted out of there. */
        if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function (event) {
            if (!event || !event.responseText) return;
            var parsed = new DOMParser().parseFromString(event.responseText, 'text/html');
            var fresh = parsed.querySelector('[data-kop3-chips]');
            if (!fresh) return;
            self.node.innerHTML = fresh.innerHTML;
            self.node.dataset.built = 'false';
            self.active = {};
            self.init();
          });
        }
      }

      this.index();
      this.verify();
      this.apply();
    },

    /* A chip filters in the browser only when the number of cards it matches
       here equals the count Shopify printed for that facet. If the two
       disagree the chip keeps the server in the loop, so an option or
       metafield facet this page cannot see is never answered wrongly.
       Only meaningful on an unfiltered view, so that is the only time it runs. */
    verify: function () {
      if (/[?&]filter\./.test(window.location.search)) return;
      var self = this;

      $$('[data-kop3-chip]', this.node).forEach(function (chip) {
        var value = chip.getAttribute('data-kop3-value');
        var badge = chip.querySelector('[data-kop3-chip-count]');
        var server = badge ? parseInt(badge.textContent, 10) : NaN;
        var client = 0;

        self.cards.forEach(function (card) {
          if (card.facets.indexOf(value) !== -1 || card.tags.indexOf(value) !== -1) client += 1;
        });

        if (!isNaN(server) && server === client && client > 0) {
          chip.setAttribute('data-kop3-mode', 'tag');
        } else if (chip.getAttribute('data-kop3-mode') !== 'url' && client === 0) {
          chip.setAttribute('data-kop3-mode', 'url');
        }
      });
    },

    index: function () {
      var map = config.cards || {};
      var grid = this.grid || document;

      this.cards = $$('.product-card', grid).map(function (card) {
        var raw = card.getAttribute('data-kop3-tags');
        var tags = raw
          ? raw.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean)
          : (map[card.getAttribute('data-kop3-handle')] || []);
        var type = (card.getAttribute('data-kop3-type') || '').trim();
        var facets = (card.getAttribute('data-kop3-facets') || '')
          .split(',').map(function (v) { return v.trim(); }).filter(Boolean);
        return { node: card, tags: tags, type: type, facets: facets };
      });
    },

    toggle: function (chip) {
      /* A chip mapped to a filter the browser cannot resolve on its own, a
         metafield or price facet for instance, hands over to the theme's own
         facet form so the server does the work. */
      if (chip.getAttribute('data-kop3-mode') === 'url') {
        this.server(chip);
        return;
      }

      var group = chip.getAttribute('data-kop3-group') || 'default';
      var value = chip.getAttribute('data-kop3-value');
      var picked = this.active[group] || [];
      var index = picked.indexOf(value);

      if (index === -1) picked.push(value);
      else picked.splice(index, 1);

      this.active[group] = picked;
      chip.setAttribute('aria-pressed', index === -1 ? 'true' : 'false');
      this.apply();
    },

    reset: function () {
      this.active = {};
      $$('[data-kop3-chip]', this.node).forEach(function (chip) {
        chip.setAttribute('aria-pressed', 'false');
      });
      this.apply();
    },

    matches: function (card) {
      var groups = Object.keys(this.active);
      for (var i = 0; i < groups.length; i += 1) {
        var picked = this.active[groups[i]];
        if (!picked || !picked.length) continue;

        /* Within one group the chips read as "any of these", across groups as
           "all of these", which is how shoppers expect facets to behave. */
        var hit = picked.some(function (value) {
          return card.facets.indexOf(value) !== -1 || card.tags.indexOf(value) !== -1;
        });
        if (!hit) return false;
      }
      return true;
    },

    apply: function () {
      var shown = 0;
      var self = this;

      this.cards.forEach(function (card) {
        var visible = self.matches(card);
        card.node.classList.toggle('kop3-hidden', !visible);
        if (visible) shown += 1;
      });

      var total = this.cards.length;
      var filtering = Object.keys(this.active).some(function (key) {
        return self.active[key] && self.active[key].length;
      });

      if (this.clear) this.clear.hidden = !filtering;
      if (this.empty) this.empty.classList.toggle('is-shown', filtering && shown === 0);

      if (this.status) {
        var copy = config.chips || {};
        this.status.textContent = filtering
          ? fill(copy.status, { shown: shown, total: total })
          : '';
      }

      /* Counts are already correct in the markup, so they are only recomputed
         once the shopper is actually filtering. That keeps the row stable at
         first paint instead of rewriting every chip on load. */
      if (!filtering) return;

      $$('[data-kop3-chip]', this.node).forEach(function (chip) {
        if (chip.getAttribute('data-kop3-mode') === 'url') return;
        var group = chip.getAttribute('data-kop3-group') || 'tag';
        var value = chip.getAttribute('data-kop3-value');
        var count = 0;
        self.cards.forEach(function (card) {
          if (card.facets.indexOf(value) !== -1 || card.tags.indexOf(value) !== -1) count += 1;
        });
        var badge = chip.querySelector('[data-kop3-chip-count]');
        if (badge) badge.textContent = String(count);
        chip.disabled = count === 0 && chip.getAttribute('aria-pressed') !== 'true';
      });
    },

    server: function (chip) {
      var url = chip.getAttribute('data-kop3-url');
      var form = document.querySelector('form[is="facet-form"]');
      if (!url) return;

      if (!form || typeof form.renderSection !== 'function') {
        window.location.href = url;
        return;
      }

      var target = new URL(url, window.location.origin);
      var sectionId = form.dataset.sectionId ||
        (form.id ? form.id.replace('FacetFiltersForm', '') : '') ||
        (window.theme && window.theme.utils && window.theme.utils.sectionId
          ? window.theme.utils.sectionId(form)
          : '');
      if (sectionId) target.searchParams.set('section_id', sectionId);

      form.renderSection(target.toString());
    }
  };

  /* ========================================================================
     Preview toolbar
     ======================================================================== */
  function toolbar() {
    var host = $('[data-kop3-toolbar]');
    if (!host || host.dataset.built === 'true') return;
    host.dataset.built = 'true';

    var handle = $('[data-kop3-toolbar-handle]', host);
    var panel = $('[data-kop3-toolbar-panel]', host);
    var rows = $('[data-kop3-toolbar-rows]', host);
    var count = $('[data-kop3-toolbar-count]', host);

    handle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      handle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    TESTS.forEach(function (test) {
      var row = document.createElement('label');
      row.className = 'kop3-toolbar__row';

      var box = document.createElement('input');
      box.type = 'checkbox';
      box.checked = on(test.id);
      box.addEventListener('change', function () {
        window.KopstormCRO[box.checked ? 'enable' : 'disable'](test.id);
        sync();
      });

      var id = document.createElement('span');
      id.className = 'kop3-toolbar__id';
      id.textContent = test.id.toUpperCase();

      var label = document.createElement('span');
      label.textContent = test.label;

      row.appendChild(box);
      row.appendChild(id);
      row.appendChild(label);
      rows.appendChild(row);
    });

    function sync() {
      var active = 0;
      $$('.kop3-toolbar__row', rows).forEach(function (row, i) {
        var box = row.querySelector('input');
        box.checked = on(TESTS[i].id);
        if (box.checked) active += 1;
      });
      if (count) count.textContent = String(active);
    }

    $('[data-kop3-toolbar-all]', host).addEventListener('click', function () {
      TESTS.forEach(function (test) { window.KopstormCRO.enable(test.id); });
      sync();
    });

    $('[data-kop3-toolbar-none]', host).addEventListener('click', function () {
      TESTS.forEach(function (test) { window.KopstormCRO.disable(test.id); });
      root.classList.remove('kop-w3preview');
      sync();
    });

    sync();
  }

  /* ========================================================================
     Boot
     ======================================================================== */
  function apply() {
    config = window.KopstormW3 || config;
    tabs();
    chips.init();
    toolbar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('kopstorm:flag', function (event) {
    if (event.detail && String(event.detail.id).indexOf('w') === 0) apply();
  });

  document.addEventListener('shopify:section:load', apply);

  window.KopstormW3API = {
    openQuiz: function () { quiz.open(); },
    closeQuiz: function () { quiz.close(); },
    refresh: apply
  };
})();
